module.exports = __webpack_public_path__ + "img/164_L.e67f682e.png";